import React from 'react'

function Kids() {
  return (
    <div>Kids</div>
  )
}

export default Kids